import { CommonDT, DateFilter, PageParams, ResultType, Sorter } from '../../CommonDT';
import { _delete, _get, _post, _put, _req, _reqLocal } from '../../request';

/**
 * 运维口令
 */
export type OpsCypherDT = {
  incId: number | null;
  /**
   * 帖子uuid
   */
  postUuid: string | null;
  /**
   * 帖子标题
   */
  postTitle: string | null;
  /**
   * 资源口令
   */
  cypherKey: string | null;
  /**
   * 来源帖子id
   */
  sourcePostId: string | null;
  /**
   * 来源热门指数
   */
  sourceHotIndex: string | null;
  /**
   * 来源图片数量
   */
  sourceImageCount: string | null;
  /**
   * 来源图片目录
   */
  sourceImageDir: string | null;
  /**
   * 目标图片目录
   */
  sickzilProjectDir: string | null;
  /**
   * 是否完成nsfw图片筛选
   */
  overNsfw: number | null;
  /**
   * 是否完成sickzil图片去字
   */
  overClear: number | null;
};

/**
 * 运维图片
 */
export type OpsImageDT = {
  /**
   * 自增id
   */
  incId: number | null;
  /**
   * 帖子uuid
   */
  postUuid: string | null;
  /**
   * 帖子标题
   */
  postTitle: string | null;
  /**
   * 资源口令
   */
  cypherKey: string | null;
  /**
   * 来源帖子id
   */
  sourcePostId: string | null;
  /**
   * 图片序号
   */
  imageNo: number | null;
  /**
   * 图片名称
   */
  imageName: string | null;
  /**
   * 图片路径
   */
  imagePath: string | null;
  /**
   * 图片链接
   */
  imageUrl: string | null;
  /**
   * 图片链接
   */
  imageUrlOnline: string | null;
  /**
   * nsfw检测值（本地）
   */
  nsfwLocalValue: string | null;
  /**
   * nsfw检测值（远程）
   */
  nsfwServeValue: string | null;
  /**
   * 发布次数
   */
  publishTimes: number | null;
  /**
   * 操作状态（0待处理，1已废弃，2已保留）
   */
  actionType: number | null;
  /**
   * 操作状态（0待处理，1已废弃，2已保留）
   */
  isNsfw: number | null;
  /**
   * 预先废弃（1已废弃）
   */
  preTrash: number | null;
  /**
   * 预先废弃单色（1已废弃）
   */
  preTrashSolid: number | null;
};

/**
 * OpsImage对象BO
 */
export type OpsProcessBO = {
  /**
   * 待处理数量
   */
  waitCount: number;
  /**
   * 已废弃数量
   */
  trashCount: number;
  /**
   * 已保留数量
   */
  keepCount: number;
};

export type PageFolderParams = {
  pageCurrent: number;
  pageSize: number;
  searchPostTitle: string;
  overNsfw: boolean;
  overClear: boolean;
  orderHotIndex: boolean;
  orderImageCount: boolean;
};

export type PageImageParams = {
  pageCurrent: number;
  pageSize: number;
  searchPostTitle: string;
  searchSourcePostId: string;
  actionType: number;
  isNsfw: boolean;
};

export type PageImageActionParams = {
  pageCurrent: number;
  pageSize: number;
  actionType: number;
  strict: boolean;
};

export type OpsActionParams = {
  actionType: number;
  imageNameList: string[];
};

export type OpsClassifyParams = {
  imageName: string;
  predictionList: PredictionDTO[];
};

export type PredictionDTO = { className: string; probability: number };
//   [
//     {
//         "className": "Neutral",
//         "probability": 0.9475597143173218
//     },
//     {
//         "className": "Drawing",
//         "probability": 0.052102766931056976
//     },
//     {
//         "className": "Hentai",
//         "probability": 0.0003102877817582339
//     },
//     {
//         "className": "Porn",
//         "probability": 0.000023271826648851857
//     },
//     {
//         "className": "Sexy",
//         "probability": 0.000003913108685082989
//     }
// ]

const pageFolder = async (params: PageFolderParams): Promise<ResultType> => {
  return await _reqLocal('/ops/sick/pageFolder', 'GET', params);
};
const pageImage = async (params: PageImageParams): Promise<ResultType> => {
  return await _reqLocal('/ops/sick/pageImage', 'GET', params);
};
const pageImageAction = async (params: PageImageActionParams): Promise<ResultType> => {
  return await _reqLocal('/ops/sick/pageImageAction', 'GET', params);
};
const pageUndetectImage = async (count: number): Promise<ResultType> => {
  return await _reqLocal('/ops/sick/pageUndetectImage', 'GET', { count });
};
const opsProcess = async (isNsfw: boolean): Promise<ResultType> => {
  return await _reqLocal('/ops/sick/opsProcess', 'GET', { isNsfw });
};
const opsAction = async (data: OpsActionParams): Promise<ResultType> => {
  return await _reqLocal('/ops/sick/opsAction', 'POST', {}, data);
};
const opsTrashPost = async (postId: string): Promise<ResultType> => {
  return await _reqLocal('/ops/sick/opsTrashPost', 'GET', { postId });
};
const opsPostImage = async (postId: string): Promise<ResultType> => {
  return await _reqLocal('/ops/sick/opsPostImage', 'GET', { postId });
};
const opsReset = async (): Promise<ResultType> => {
  return await _reqLocal('/ops/sick/opsReset', 'GET');
};
const opsClassify = async (data: OpsClassifyParams): Promise<ResultType> => {
  return await _reqLocal('/ops/sick/opsClassify', 'POST', {}, data);
};
const opsPublish = async (params: string): Promise<ResultType> => {
  return await _reqLocal('/ops/sick/opsPublish', 'GET', { params });
};

const SickzilApi = {
  pageFolder,
  pageImage,
  pageImageAction,
  pageUndetectImage,
  opsProcess,
  opsAction,
  opsTrashPost,
  opsPostImage,
  opsReset,
  opsClassify,
  opsPublish,
};

export default SickzilApi;
